<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
         <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
			<el-button type="primary" @click="createApproval" v-if="userPermissions.indexOf('businessapproval_add') != -1">新增</el-button>
			<!-- <el-button type="primary" @click="createApproval">新增</el-button> -->
          </el-form>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" :current_Page="currentPage" @switchPaging="switchPaging" highlight-current-row >
			<el-table-column
				slot="first-column"
				align="center"
				label="合同编号">
				<template slot-scope="scope">
					<div>{{ scope.row.contract_id }}</div>
				</template>
			</el-table-column>
			<el-table-column
				slot="first-column"
				align="center"
				label="服务项目内容">
				<template slot-scope="scope">
					<div>{{ scope.row.content }}</div>
				</template>
			</el-table-column>
			<el-table-column
				slot="first-column"
				align="center"
				label="商家名称">
				<template slot-scope="scope">
					<div>{{ scope.row.name }}</div>
				</template>
			</el-table-column>
			<el-table-column
				slot="first-column"
				align="center"
				label="商家社会信用代码">
				<template slot-scope="scope">
					<div>{{ scope.row.taxpayer }}</div>
				</template>
			</el-table-column>
            <el-table-column
              width="160"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button slot="reference" size="mini" type="infor" @click="mxPreview1(scope.row.file_url)">详情</el-button>
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="refuseRules" ref="refuseForm" label-position="right" label-width="96px">
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="渠道账号" prop="channel_account">
							<el-input v-model="formData.channel_account"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="合同编号" prop="contract_id">
							<el-input v-model="formData.contract_id"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="服务项目内容" prop="content">
							<el-input v-model="formData.content"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="商家名称" prop="name">
							<el-input v-model="formData.name"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="商家社会信用代码" prop="taxpayer">
							<el-input v-model="formData.taxpayer"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="姓名" prop="realname">
							<el-input v-model="formData.realname"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="bill-info">
						<el-form-item label="身份证号" prop="id_number">
							<el-input v-model="formData.id_number"/>
						</el-form-item>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="上传审批表" class="bill-info" prop="file_url">
						<upload-file
							class="upload-contract"
							@remove_file="handleRemoveFile"
							@return_url="handUploadFile"
							@before_upload="beforeUpload"
							:title="'灵活用工平台服务项目归档审批表'"
							:multiple="'false'"
							:multiSelection="false"
							:dir="'bill'"
							:selectfiles="'importExcel'"
							:postfiles="'submitImportExcel'"
							:ossfile="'ossExcelFile'"
							:max_width="1000"
							:max_height="1000"
							:fileUrl="formData.file_url"
						/>
					</el-form-item>
				</el-col>
			</el-row>
        </el-form>
      </template>
    </ModalDialog>
    <verification
      @dialogChanged="dialogBillChanged($event)"
      @onSuccess="handleBillSuccess($event)"
      :dialogBillVisible="dialogBillVisible"
      :billId="billId" />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import Verification from '@/components/Verification.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'
import UploadFile from "@/components/UploadFile";
import { MessageBox } from 'element-ui'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    Verification,
	ScreeCompany,
	UploadFile
  },
  data() {
    return {
      rejectList: [
        {
          label: 1,
          name: '服务金额与附件表中金额不符'
        },
        {
          label: 2,
          name: '服务金额是实际下发金额，不含税'
        },
        {
          label: 3,
          name: '服务成果验收及计酬核算单未盖章'
        },
        {
          label: 4,
          name: '业务清单结算依据和结算量填写不正确'
        }
      ],
      reason: '',
      currentPage: 1,
      refuseData: {//拒绝提交数据
        desc: ''
      },
      refuseRules: {
			channel_account :[{required: true, message: '请输入渠道账号', trigger: 'blur'}],
			contract_id :[{required: true, message: '请输入合同编号', trigger: 'blur'}],
			content :[{required: true, message: '请输入服务项目内容', trigger: 'blur'}],
			name :[{required: true, message: '请输入商家名称', trigger: 'blur'}],
			taxpayer :[{required: true, message: '请输入商家社会信用代码', trigger: 'blur'}],
			realname :[{required: true, message: '请输入姓名', trigger: 'blur'}],
			id_number :[{required: true, message: '请输入身份证号', trigger: 'blur'}],
			file_url :[{required: true, message: '请上传审批表', trigger: 'blur'}]
		},
      activeName: 'untreated',
      tabsList: [
        {
          label: '未处理',
          name: 'untreated'
        },
        {
          label: '已处理',
          name: 'reviewed'
        },
      ],
      billId: '',
      dialogBillVisible: false,
      source: 'saas',
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: false,
      columns: [],
      // 表格列表数据
      dataList:[  ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '新增',
        width: '50%',
        loading: false,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text",load_text)
    },
     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename, load_text, title}) {
      console.log("->上传成功....", url, filename, load_text, title);
      this.formData.file_url = url
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1
    },
    //选择原因
    changeReason() {
      this.rejectList.forEach(item => {
        if(item.label == this.reason) {
          this.refuseData.desc = item.name
        }
      })
    },
    //拒绝
    refuse(id, type) {
      this.dialogData.visible = true
      this.refuseData.id = id
      this.refuseData.type = type
    },
    //切换tab
    async handleClick(tab) {
      if(tab.name == 'untreated') {//等待用户上传
        this.searchCondition.type = 0
        this.init(0)
      }else if(tab.name == 'reviewed') {//审核中
        this.searchCondition.type = 1
        this.init(1)
      }
      this.resetPage()
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        if(v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }

      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    //切换系统
    changeSelc() {
      console.log(this.source, "saas")
    },
    // 搜索
    searchButton() {
      this.init()
    },
    // 切换页码操作
    async switchPaging(val) {
      if(val) {
        this.currentPage = val
      }else {
        this.currentPage = 1
      }
      this.init()
    },
    // 响应详情按钮
    async viewButton(id, type) {
      this.formData.id = id
      this.formData.type = type
    },
    handleBillSuccess() {
      this.$message.success('验证成功')
      this.dialogBillVisible = false
    },
    dialogBillChanged(state) {
      this.dialogBillVisible = state
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化列表
    async init(type) {
		if(type) {
			this.mxResetPage()
		}
		this.loadingStaus=true
		let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
		let searchCondition = this.handleSearchCondition()
		Object.assign(searchCondition,pagingInfo)
		let { data, pages } = await this.$api.getAdminBusinessApprovalList(searchCondition)
		this.$nextTick(() => {
			this.dataList = data
		})
		this.pagingData.total = pages.total
		this.offset = pages.offset
		this.loadingStaus=false
		this.dialogData.visible=false
		this.formData={};
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.id) {
        condition.id = this.searchCondition.id
      }
      if (this.searchCondition.channel_name) {
        condition.channel_name = this.searchCondition.channel_name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      condition.type = 0
      if(this.searchCondition.type || this.searchCondition.type == 0) {
        condition.type = this.searchCondition.type
      }
      if (this.searchCondition.company_id || this.searchCondition.channel_account) {
        condition.company_id = this.searchCondition.company_id
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    async formRefuseSubmit( ){
      this.dialogData.loading_text = '正在提交中……'
		console.log(this.formData)
      // this.refuseData.company_id = this.currentCompanyId
      await this.$api.saveAdminBusinessApprovalAudit(this.formData)
		this.$message.success('保存成功!')
		this.init()
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['refuseForm'].validate((valid) => {
        if (valid) {
          this.formRefuseSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.reason = ''
      // this.formData = {}
      // this.attachmentUploadFileList = []
      this.refuseData = {}
    },
    keyupSubmit(){
      document.onkeydown = () => {
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
	createApproval(){
		this.dialogData.visible = true
	},
    // 预览文件
    mxPreview1 (url) {
		console.log(url,"url")
		if(url) {
			let arr = url.split(".")
			let suffixName = arr[arr.length - 1].toLowerCase()
			console.log(suffixName,"suffixName")
			if(suffixName == 'xls' || suffixName == 'xlsx' || suffixName == 'doc' || suffixName == 'docx'|| suffixName == 'ppt' || suffixName == 'pptx'){
				const href = `https://view.officeapps.live.com/op/view.aspx?src=${url}`
				window.open(href, '_blank')
			}else {
				const href = url
				window.open(href, '_blank')
			}
		}else {
			let errMsg = '暂无文件，请先上传审批表'
			MessageBox.alert(errMsg,'系统提示',{
				confirmButtonText: '确定',
				type: 'error',
			})
		}
	}
  },
  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
  .el-input-group__append
    color #ffffff
    background #1890ff
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .changeBtn
    display: flex
    flex-direction: row
    width: 1110px
  // .demo-form-inline
  //   padding-top: 20px
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
  .el-form--inline .el-form-item
    margin-right: 30px
  .reason
    display: flex
    flex-direction: column
    padding-left: 20px
  .tag-group
    display: flex
    flex-direction: column
  .tag-item
    margin: 5px 0
  // .table-search
  //   height: 36px
</style>
